/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum SoftwareStatusRepresentations {
    Unknown = 0,
    Installed = 1,
    NotInstalled = 2,
}
